// CASAIDEAS TEMPLATE

import type {
    BaseConfig,
    UrlConfig,
    ModelUrlConfig,
    ModelUrlData,
    MenuConfig
} from '@preload/graphql/getConfig.d'

export enum SubmenuMode {
    BLOCK = 'cms_block',
    SUBCATEGORY = 'subcategory'
}

export enum ModelTypeEnum {
    CATEGORY = 'category',
    PRODUCT = 'product',
    CMS_PAGE = 'cmsPage'
}

export type ModelType = keyof Omit<ModelUrlConfig, '__typename'>

export type FrontendBaseConfig = BaseConfig & {
    loqate: {
        enabled: boolean
        findEndPoint: string
        retrieveEndPoint: string
        validateEndPoint: string
        api_key: string
    }
    url: UrlConfig & {
        baseUrl: string
        model: {
            [key in ModelType]: ModelUrlData & {
                directory: string
            }
        }
        media: {
            cms: string
            home: string
        }
        path: {
            shippingSettings: string
        }
    }
    menu: Required<Omit<MenuConfig, '__typename'>> & {
        submenu: SubmenuMode | string
    }
    wishlist: {
        enabled: boolean
        multiple_wishlists: boolean
    }
    shipping: {
        addressCountry: string[]
        includeShippingDetails: boolean
    }
    yotpo: {
        enabled: boolean
        api_key: string
    }
    customer?: {
        gift_card_payment_enabled?: boolean
        store_credit_enabled?: boolean
    }
    price?: {
        currencySymbol: string[]
    }
}

export const base: FrontendBaseConfig = {
    loqate: {
        enabled: false,
        findEndPoint:
            'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws',
        retrieveEndPoint:
            'https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws',
        validateEndPoint:
            'https://api.addressy.com/Cleansing/International/Batch/v1.00/json4.ws',
        api_key: ''
    },
    url: {
        baseUrl: 'https://www.casaideas.cl/',
        model: {
            category: {
                suffix: '',
                directory: 'categoria'
            },
            product: {
                suffix: '',
                directory: 'producto'
            },
            cmsPage: {
                suffix: '',
                directory: 'contenido'
            }
        },
        media: {
            cms: 'wysiwyg/social_media/cms',
            home: 'wysiwyg/social_media/home'
        },
        path: {
            shippingSettings: 'content/ordering-info'
        }
    },
    menu: {
        submenu: SubmenuMode.BLOCK,
        submenu_maxitems: 10
    },
    wishlist: {
        enabled: true,
        multiple_wishlists: false
    },
    shipping: {
        addressCountry: ['AU, NZ, AL, DZ, EE, IR, IQ, AF'],
        includeShippingDetails: false
    },
    yotpo: {
        enabled: false,
        api_key: ''
    },
    customer: {
        gift_card_payment_enabled: true,
        store_credit_enabled: true
    }
}

export default base
